// 🔧 schedule_defaults.js
// ✅ Purpose: Creates schedule template data for Seed Engine events
// ✅ Features:
// - Uses the same fields expected by Event Home schedule display
// - Creates realistic car show schedule items
// - Supports scheduleDate, startTime, endTime, and sortStartMinutes
// - Future-ready for industry-specific schedules
// - Fully block-commented for clarity and future devs

const padTime = (value) => {
  return String(value).padStart(2, "0");
};

const buildTimeValue = ({
  hour,
  minute = 0,
} = {}) => {
  return `${padTime(hour)}:${padTime(minute)}`;
};

const buildScheduleDateValue = ({
  eventDoc,
} = {}) => {
  const rawStartDate =
    eventDoc?.startDate?.toDate
      ? eventDoc.startDate.toDate()
      : new Date();

  return rawStartDate.toISOString().slice(0, 10);
};

const buildSortMinutes = ({
  hour,
  minute = 0,
} = {}) => {
  return Number(hour || 0) * 60 + Number(minute || 0);
};

export const buildDemoScheduleItems = ({
  eventDoc,
} = {}) => {
  const scheduleDate = buildScheduleDateValue({
    eventDoc,
  });

  return [
    {
      title: "Gates Open",
      description:
        "Attendees arrive, check in, and begin exploring the show field.",
      location: "Main Entrance",
      scheduleDate,
      startTime: buildTimeValue({ hour: 8, minute: 0 }),
      endTime: buildTimeValue({ hour: 9, minute: 0 }),
      sortStartMinutes: buildSortMinutes({ hour: 8, minute: 0 }),
      displayOrder: 1,
    },

    {
      title: "Participant Check-In",
      description:
        "Vehicle owners check in and receive event information.",
      location: "Registration Tent",
      scheduleDate,
      startTime: buildTimeValue({ hour: 8, minute: 30 }),
      endTime: buildTimeValue({ hour: 10, minute: 0 }),
      sortStartMinutes: buildSortMinutes({ hour: 8, minute: 30 }),
      displayOrder: 2,
    },

    {
      title: "Voting Opens",
      description:
        "Attendees can scan QR codes and cast their demo votes.",
      location: "Show Field",
      scheduleDate,
      startTime: buildTimeValue({ hour: 10, minute: 0 }),
      endTime: buildTimeValue({ hour: 14, minute: 0 }),
      sortStartMinutes: buildSortMinutes({ hour: 10, minute: 0 }),
      displayOrder: 3,
    },

    {
      title: "Sponsor Recognition",
      description:
        "Event sponsors are recognized before the final award announcements.",
      location: "Awards Stage",
      scheduleDate,
      startTime: buildTimeValue({ hour: 13, minute: 30 }),
      endTime: buildTimeValue({ hour: 14, minute: 0 }),
      sortStartMinutes: buildSortMinutes({ hour: 13, minute: 30 }),
      displayOrder: 4,
    },

    {
      title: "Awards Presentation",
      description:
        "Demo winners are announced and leaderboard results are reviewed.",
      location: "Awards Stage",
      scheduleDate,
      startTime: buildTimeValue({ hour: 15, minute: 0 }),
      endTime: buildTimeValue({ hour: 16, minute: 0 }),
      sortStartMinutes: buildSortMinutes({ hour: 15, minute: 0 }),
      displayOrder: 5,
    },
  ];
};